import React, { PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
  className?: string;
}

export const AbsoluteCenter: React.FC<Props> = ({ children, className = "" }) => {
  return <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ${className}`}>{children}</div>;
};

export const Center: React.FC<Props> = ({ children, className = "" }) => {
  return <div className={`flex items-center justify-center ${className}`}>{children}</div>;
};

export const HorizontalCenter: React.FC<Props> = ({ children, className = "" }) => {
  return <div className={`flex items-center ${className}`}>{children}</div>;
};

export const VerticalCenter: React.FC<Props> = ({ children, className = "" }) => {
  return <div className={`flex flex-col items-center ${className}`}>{children}</div>;
};
export const Row: React.FC<Props> = ({ children, className = "" }) => <div className={`py-1 flex gap-y-1 items-center ${className}`}>{children}</div>;

export const Col: React.FC<Props> = ({ children, className = "" }) => <div className={`py-1 flex flex-col gap-x-4 ${className}`}>{children}</div>;

type SeparatorProps = {
  isVertical?: boolean;
  className?: string;
};

const Separator: React.FC<SeparatorProps> = ({ isVertical = false, className = "" }) => {
  return <div className={`${isVertical ? "w-px" : "h-px"} ${className}`} role="separator" />;
};

export default Separator;
